import { BaseEntry, CustomLink, Media } from "@/types";

export enum LayoutType {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

export enum ColumnType {
  IMAGE = "amenityColumnFullImage",
  TEXT = "amenityColumnOnlyText",
  TEXTIMAGE = "amenityColumnTextImage",
}

export interface ImageAmenityColumn extends AmenityColumn {
  image: Media;
}

export interface TextAmenityColumn extends AmenityColumn {
  text: string;
}

export interface ImageTextAmenityColumn extends AmenityColumn {
  image: Media;
  text: string;
  textPosition: string;
}

export interface AmenityColumn {
  layout: LayoutType;
  type: ColumnType;
}

interface Amenity extends BaseEntry {
  labelIcon: CustomLink;
  columns: AmenityColumn[];
}

export interface TabbedCarousel extends BaseEntry {
  title: string;
  amenities: Amenity[];
  textColor?: string;
  backgroundColor?: string;
}

export interface TabbedCarouselData {
  entry: TabbedCarousel;
}
